<template>
    <v-dialog v-model="dialog" max-width="700" :class="darkTheme">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" text>
                <font-awesome-icon :icon="icons.goals" class="fa-fw fa-lg"></font-awesome-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('Home.dashboard.overview.objectivesOverview.title') }}</span>
            </v-card-title>
            <v-card-text>
                <div class="objectivesOverview">
                    <ObjectiveCard v-for="(obj, idx) in userObjectives" :key="idx" :objective="obj"></ObjectiveCard>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn fab small dark @click="cancel">
                    <font-awesome-icon :icon="icons.cancel" class="fa-fw fa-lg"></font-awesome-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { faTrophy } from '@fortawesome/pro-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import ObjectiveCard from './ObjectiveCard.vue';
export default {
	components: { ObjectiveCard },
    props: {
        dark: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
            icons: {
                goals: faTrophy,
                cancel: faTimes
            }
        }
    },
    computed: {
        darkTheme() {
            return this.dark ? 'dark' : '';
        },
        userObjectives() {
            return [...this.$store.getters.getObjectives].sort((a, b) => {
                return a.percentageOfProgression - b.percentageOfProgression;
            }).toReversed();
        }
    },
    methods: {
        cancel() {
            this.dialog = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.dark .v-btn.v-btn--icon {
    color: #FFF;
}
.objectivesOverview{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>